var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 422 422",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 241 110 C 250 114 259 117 268 121 284 128 300 132 320 130 357 126 387 149 397 182 407 214 392 248 360 265 329 281 291 275 266 250 261 244 253 241 247 237 243 235 239 234 235 231 180 202 120 195 59 200 43 201 29 200 22 184 16 170 21 159 33 149 41 143 40 136 32 129 21 120 16 109 22 96 28 81 41 78 56 79 71 79 86 79 100 79 152 69 196 94 241 110 Z M 324 253 C 353 253 377 229 378 202 378 174 353 150 324 150 294 150 269 173 269 201 269 229 294 253 324 253 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 251 L 20 216 C 57 217 94 218 132 218 162 218 164 220 160 251 L 20 251 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 19 270 L 161 270 161 301 19 301 19 270 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 320 C 161 324 161 328 162 333 163 347 158 353 141 352 108 351 74 352 41 352 18 352 18 352 19 330 19 327 19 324 19 320 L 160 320 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStem);
export default __webpack_public_path__ + "static/media/stem.4303d563df1b08a9f40edff6e8d1b61e.svg";
export { ForwardRef as ReactComponent };